import { FC } from "react";

import { Alert } from "@livechat/design-system-react-components";

import Block from "components/layout/Block";
import { StyledLink } from "components/links/StyledLink";
import { AgentsRoutes } from "routes/agents/constants";

export const NonAdminAlert: FC = () => (
  <Block maxWidth="800px">
    <Alert kind="info">
      You can&apos;t manage widget in your current HelpDesk role.{" "}
      <StyledLink kind="link-light" to={AgentsRoutes.Agents}>
        Contact any admin
      </StyledLink>{" "}
      to change your role to admin.
    </Alert>
  </Block>
);
